// IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика) — связка графика (AttrChart) с формой ячейки (Dropdown.vue, store.dropdown):
// клик по точке линии / блоку столбика открывает ту же форму, что у ячейки таблицы, у этого кусочка — шапка (серия, период, значение), блоки
// детализации по измерениям источника (первые N по объёму + «Others…», полосы долей, переход в запись), команда «Split» (разбить эту серию в текущем
// графике по измерению: series_dimension / series_limit меры + колонка измерения в полях виджета — в памяти, запись помечается изменённой, сохраняет
// пользователь; «Undo split» — откат), блок настроек «Breakdown settings» (что предложено по умолчанию — ★, выбор измерений и топа; хранение —
// viewParams.<chart>.drill-dims / drill-top). Детализацию считает бэк: метод виджета chart_drill (common_modules/chart_drill.py).
// Клик (решение Игоря 27.09): обычный — форма; Alt+клик — прежний обычный клик (окно легенды: открыть закрытое / перевести на дату точки); опция
// click-open-row («Click on a point: Opens the row widget») — форма не открывается, клик и Alt+клик — как раньше (окно строки); Shift+клик и протяжка —
// выбор периода, как раньше (дата точки выбирается и обычным кликом — по нажатию мыши, как было); телефон — как раньше (значение у пальца). Открытое
// окно легенды по-прежнему следует за датой клика. Точка под курсором — по правилам плашки значений p199A (chartDrill_hit).
// Выключатели: настройка базы fe.ux.chartDrill (window.feSettings.set('fe.ux.chartDrill', false) / URL ?fe.ux.chartDrill=false) — клик, шестерёнка и
// объяснения по Alt как до правки; у графика — шестерёнка → «Click on a point: Breakdown form» (viewParams.<chart>.click-drill = false).
// Счётчики и замеры: window._chartDrill (opens / requests / answers / ms — время ответа бэка, last — последний ответ, formH — высота последней формы с ответом).
// IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды — «форму расшифровки (top 5…) показывай как отдельную вкладку в форме легенды»): у графика
// с окном легенды (кнопка 🏷, isLegendGroupedActive) расшифровка — вкладка Breakdown окна легенды (ChartLegendPanel, вкладки [Breakdown | Legend] на AttrTabPanel),
// а не форма у кусочка: простой клик по точке / столбику — кусочек выбирается, как в форме (chartDrill_hit), закрытое окно легенды открывается, дата легенды — дата
// кусочка, привязка-стрелка — к кусочку (как прежний клик по точке до формы), Breakdown грузит расшифровку (chart_drill; открыта вкладка Legend — при переходе на
// Breakdown). Вкладку выбирает только пользователь — выбор держится на графике до перезагрузки (WIDGET._chartLegendTab, в памяти); без клика во вкладке —
// строка-подсказка; пришли другие строки графика — расшифровка устарела (строка-подсказка). Alt+клик — как до формы (окно легенды не трогать; при «Opens the row
// widget» — окно строки). График без окна легенды — форма у кусочка, как было. Выключатель fe.ux.chartDrillTab (false — форма у кусочка на всех графиках).
// Счётчики — window._chartDrill.tab (clicks / legendOpened / requests / deferred / repeat / switches / stale), tabH — высота последней расшифровки во вкладке,
// tipOffMoves — проходы по датам без плашки у точки (AttrChart.chartPointTipOff).
import { toRaw } from 'vue'   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): сравнение строк графика и модели формы без прокси
import { drillTop, drillDims, drillPoint, drillParams, drillBlockRows, drillFmt, drillSplitApply, drillSplitUndo, drillSplitRemove, drillCssColor, DRILL_OTHERS_KEY } from '@/utils/chartDrill'
import { legendSeriesColor } from '@/utils/chartLegend'
import { chartSplitBack_on, splitBackRecKey, splitBackCan, splitBackSnapshot, splitBackPush, splitBackPop, splitBackAfterUnsplit } from '@/utils/chartSplitBack'   // IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий)

const STATS = { opens: 0, requests: 0, answers: 0, unsupported: 0, splits: 0, undos: 0, backs: 0, ms: [], last: null, formH: 0,
    tab: { clicks: 0, legendOpened: 0, requests: 0, deferred: 0, repeat: 0, switches: 0, stale: 0, pinKept: 0 }, tabH: 0, tipOffMoves: 0 }   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): tab, tabH, tipOffMoves
try { if (typeof window !== 'undefined') window._chartDrill = STATS } catch (e) { /* без window */ }

const BLOCKS_KEY = 'fe.chartDrill.blocks'

export const chartDrillMixin = {
    // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): модель расшифровки вкладки Breakdown (последний кликнутый кусочек; null — строка-подсказка)
    // и выбранная вкладка окна легенды (зеркало WIDGET._chartLegendTab)
    data() {
        return { legendDrill: null, legendTabSel: null, splitBackTick: 0 }   // IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий): splitBackTick — перерисовать стрелку после смены стека
    },
    methods: {
        // выключатель механизма на всё приложение (выкл — клик, шестерёнка и объяснения по Alt — как до правки)
        chartDrill_globalOn() {
            try { return this.store.setting('fe.ux.chartDrill', true) !== false } catch (e) { return true }
        },
        chartDrill_on() {
            try {
                if (!this.chartDrill_globalOn()) return false
                if (this.store.mobileUi?.on) return false
                if (this.isPieMode?.() || this.isAntMode?.()) return false
                if (!this.WIDGET || !this.flex || this.attr?.['tooltip-inline']) return false   // синтетические графики (форма ячейки, вкладка Analysis) — без формы
                return this.get_viewParam('click-drill', true) !== false
            } catch (e) { return false }
        },
        // Alt+клик при включённой форме — прежний простой клик (окно легенды): chart_onClick снимает у него признак «Alt»; при опции click-open-row
        // (клик открывает окно строки, формы нет) Alt+клик — как раньше (окно легенды не трогать, только окно строки)
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): расшифровка во вкладке Breakdown окна легенды вместо формы — у графика с окном легенды
        chartDrill_altLegacy() { return this.chartDrill_on() && this.attr?.['click-open-row'] !== true && !this.chartDrill_tabOn() },   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): у вкладки Alt+клик — как до формы
        chartDrill_tabOn() {
            try {
                if (!this.chartDrill_on() || this.store.setting('fe.ux.chartDrillTab', true) === false) return false
                return !!this.isLegendGroupedActive?.()
            } catch (e) { return false }
        },
        // режим для объяснений по Alt (vars.drill): 0 — клик как до формы, 1 — форма у кусочка, 2 — вкладка Breakdown окна легенды
        chartDrill_helpMode() { return this.chartDrill_tabOn() ? 2 : (this.chartDrill_on() ? 1 : 0) },
        chartDrill_count(key) { try { if (key in STATS.tab) STATS.tab[key]++; else STATS[key] = (Number(STATS[key]) || 0) + 1 } catch (e) { /* без счётчика */ } },
        // клик по графику: форма у точки / блока (true — клик обработан формой); мимо точек — закрыть свою форму
        chartDrill_click(e, opt = null) {
            const _shiftOk = !!(opt && opt.shift)   // IE 2026 10 13 / ODOO-5800: у графика с селекторами клика (utils/chartClickSelectors) форма — по Shift+клику
            if (!e || e.altKey || (e.shiftKey && !_shiftOk) || e.ctrlKey || e.metaKey || !this.chartDrill_on()) return false   // IE 2026 10 13 / ODOO-5800: _shiftOk
            if (this.attr?.['click-open-row'] === true) return false
            const _dateX = ['', 'date', 'date_parse'].includes(String(this.attr?.axisX_bindingX2 || ''))   // IE 2026 10 13 / ODOO-5800: Shift по категориям — не протяжка периода
            if ((!_shiftOk || _dateX) && this.mouseSelecting && this.mouseSelecting.i1 !== this.mouseSelecting.i2) return false   // протяжка по датам — выбор периода · IE 2026 10 13 / ODOO-5800
            if (this.chartDrill_tabOn()) return this.chartDrill_tabClick(e)   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): 'tab' — клик обработан вкладкой
            const dd = this.store.dropdown
            const hit = this.chartDrill_hit(e)
            const mine = dd && dd.visible && dd.chart_drill && dd._chartDrillOwner === this
            if (!hit) { if (mine && !dd.pinned) dd.hide(); return false }
            if (mine && dd.chart_drill.pointKey === hit.pointKey && !dd.pinned) { dd.hide(); return true }   // повторный клик по тому же кусочку — закрыть
            this.chartDrill_open(hit)
            return true
        },
        // точка под курсором: серия, строка, индекс, прямоугольник кусочка (столбик — его блок, линия — квадрат 14 px вокруг точки). Порядок подбора:
        //   (1) элемент под курсором принадлежит серии (её <g> в общей группе .wj-series-group): столбик — по своему прямоугольнику (у стопки столбиков
        //       hitTest wijmo называл соседа по значению), линия — точка этой серии на ближайшей дате (как дата плашки значений p199A);
        //   (2) рядом с линией, но не по ней — та же серия, что отмечена в плашке значений (hoverPick: ≤ 15 px до кривой, столбик под курсором);
        //   (3) hitTest wijmo (≤ 10 px до точки) — прежнее правило
        chartDrill_hit(e) {
            const flex = this.flex, host = flex && flex.hostElement, data = this.data || []
            if (!host || !data.length) return null
            const vis = (s) => !!s && s.visibility !== 2 && s.visibility !== 3
            const isBar = (s) => { const ct = s.chartType ?? flex.chartType; return ct === 0 || ct === 1 || ct === 'Column' || ct === 'Bar' }
            const num = (v) => (v === null || v === undefined || v === '' || typeof v === 'boolean' || !Number.isFinite(Number(v))) ? null : Number(v)
            const hr = host.getBoundingClientRect()
            const xPx = (k) => { try { const bx = flex.bindingX; return flex.axisX.convert(this.hoverXNum(bx ? data[k]?.[bx] : k, k)) } catch (err) { return NaN } }
            let series = null, i = -1, how = ''
            let tgt = e && e.target
            // над кусочком лежит свой слой графика (подсветка выбранной даты rect.chart-zone-selected после клика по ней, другие зоны) — клик достаётся ему,
            // а не серии (dev02 29.09: второй клик по той же дате формы не открывал): берём элемент серии этого графика под курсором
            if (tgt && tgt.closest && !tgt.closest('.wj-series-group') && Number.isFinite(e.clientX) && typeof document.elementsFromPoint === 'function') {
                const under = document.elementsFromPoint(e.clientX, e.clientY).find(x => x !== tgt && x.closest && x.closest('.wj-series-group') && host.contains(x))
                if (under) tgt = under
            }
            if (tgt && tgt.closest && tgt.closest('.wj-series-group')) {
                const s = (flex.series || []).find(x => vis(x) && x.hostElement && x.hostElement.contains && x.hostElement.contains(tgt)) || null
                if (s && isBar(s)) {
                    for (let k = 0; k < data.length; k++) {
                        let el = null
                        try { el = typeof s.getPlotElement === 'function' ? s.getPlotElement(k) : null } catch (err) { el = null }
                        if (el && (el === tgt || (el.contains && el.contains(tgt)))) { series = s; i = k; how = 'bar'; break }
                    }
                } else if (s) {
                    const mx = e.clientX - hr.left
                    let bd = Infinity
                    for (let k = 0; k < data.length; k++) {
                        if (num(data[k]?.[s.binding]) === null) continue
                        const d = Math.abs(xPx(k) - mx)
                        if (Number.isFinite(d) && d < bd) { bd = d; i = k }
                    }
                    if (i >= 0) { series = s; how = 'line' }
                }
            }
            if (!series && typeof this.hoverPick === 'function') {
                let hp = null
                try { hp = this.hoverPick(flex, e) } catch (err) { hp = null }
                if (hp && hp.series && vis(hp.series) && hp.pointIndex >= 0) { series = hp.series; i = hp.pointIndex; how = 'pick' }
            }
            if (!series) {
                let ht = null
                try { ht = flex.hitTest(e) } catch (err) { ht = null }
                if (ht && ht.series && ht.item && Number.isFinite(ht.distance) && ht.distance <= 10) { series = ht.series; i = data.indexOf(ht.item); how = 'hitTest' }
            }
            if (!series || i < 0 || i >= data.length) return null
            const binding = series.binding, item = data[i]
            const attr = this.attrs_by_binding?.[binding] || {}
            if (attr.attr_type && !['AttrNumber', 'AttrDays', 'AttrTime'].includes(attr.attr_type)) return null
            let box = null
            if (isBar(series)) {
                try {
                    const el = typeof series.getPlotElement === 'function' ? series.getPlotElement(i) : null
                    const r = el && el.getBoundingClientRect ? el.getBoundingClientRect() : null
                    if (r && r.width >= 1 && r.width <= Math.max(48, hr.width * 0.25) && r.height <= hr.height) box = { left: r.left, top: r.top, width: r.width, height: Math.max(4, r.height) }
                } catch (err) { box = null }
            }
            if (!box) {
                let px = xPx(i), py = NaN
                try { py = (series.axisY || flex.axisY).convert(num(item[binding]) ?? 0) } catch (err) { py = NaN }
                if (!Number.isFinite(px)) px = e.clientX - hr.left
                if (!Number.isFinite(py)) py = e.clientY - hr.top
                box = { left: hr.left + px - 7, top: hr.top + py - 7, width: 14, height: 14 }
            }
            // узкий кусочек (точка линии, тонкий столбик) — якорь шириной 40 px по его центру: форма ячейки встаёт на 20 px правее левого края якоря
            // (Dropdown.marginLeft), т. е. её левый край — под центром кусочка, и мышь идёт от точки прямо вниз в форму, не уходя с якоря
            if (box.width < 40) { const cx = box.left + box.width / 2; box.left = cx - 20; box.width = 40 }
            return { series, binding, attr, item, pointIndex: i, box, how, pointKey: binding + '|' + i }
        },
        chartDrill_xKey() {
            const k = this.attr?.axisX_bindingX2
            return !k || k === 'date_parse' ? 'date' : k
        },
        chartDrill_xText(item, xKey) {
            const v = item ? item[xKey] : ''
            try {
                if (this.flex?.bindingX && String(this.flex.bindingX).endsWith('.title')) return String(this.store.get_value(item, this.flex.bindingX) || v || '')
                const m = String(v || '').match(/^(\d{4})-(\d{2})(?:-(\d{2}))?/)
                if (m) {
                    const d = new Date(+m[1], +m[2] - 1, +(m[3] || 1)), loc = this.store.ui_locale?.()
                    if (this.freq === 'A') return m[1]
                    if (this.freq === 'M' || !m[3] || m[3] === '01') return d.toLocaleString(loc, { month: 'long', year: 'numeric' })
                    return d.toLocaleDateString(loc)
                }
            } catch (e) { /* как есть */ }
            return String(v ?? '')
        },
        // невидимый якорь формы в контейнере графика: форма стоит у кусочка, как у ячейки (Dropdown.calc_position по divCell)
        chartDrill_anchor(box) {
            const cont = this.$refs.attr_container
            if (!cont) return null
            let el = this._drillAnchorEl
            if (!el || !el.isConnected || el.parentNode !== cont) {
                el = document.createElement('div')
                el.className = 'chart-drill-anchor'
                el.style.cssText = 'position:absolute;pointer-events:none;visibility:hidden;z-index:0;'
                cont.appendChild(el)
                this._drillAnchorEl = el
            }
            // координаты — от блока, относительно которого якорь позиционируется (offsetParent; контейнер графика может быть static)
            const op = el.offsetParent || cont
            const cr = op.getBoundingClientRect()
            el.style.left = Math.round(box.left - cr.left - (op.clientLeft || 0) + (op.scrollLeft || 0)) + 'px'
            el.style.top = Math.round(box.top - cr.top - (op.clientTop || 0) + (op.scrollTop || 0)) + 'px'
            el.style.width = Math.max(4, Math.round(box.width)) + 'px'
            el.style.height = Math.max(4, Math.round(box.height)) + 'px'
            return el
        },
        // запас высоты формы до первого ответа — высота прошлой формы с ответом (160…520 px, первая — 340): блок «Breaking the value down…» занимает
        // её, и форма ячейки сразу выбирает сторону, где ответ поместится (сторона выбирается один раз при показе — Dropdown.fit_apply, fe.ux.dropdownSideOnce;
        // без запаса маленькая форма загрузки вставала под высоким столбиком у оси X, а ответ потом прокручивался в полоске 100–150 px)
        chartDrill_reserveH(tab = false) {
            const h = Number(tab ? STATS.tabH : STATS.formH)   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): во вкладке — высота прошлой расшифровки вкладки
            return Math.min(520, Math.max(160, Number.isFinite(h) && h > 0 ? Math.round(h) : 340))
        },
        chartDrill_blocksMem() {
            try { return JSON.parse(localStorage.getItem(BLOCKS_KEY) || '{}') || {} } catch (e) { return {} }
        },
        chartDrill_open(hit) {
            const dd = this.store.dropdown
            if (!dd) return
            const anchor = this.chartDrill_anchor(hit.box)
            if (!anchor) return
            STATS.opens++
            const model = this.chartDrill_model(hit, anchor)   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): модель — общая с вкладкой Breakdown
            this.chartDrill_takeDropdown(dd, anchor, model)
            // дальше — только через реактивную обёртку модели (data формы): изменения сырого объекта Vue не отслеживает
            const m = dd.chart_drill
            m.ctl = this.chartDrill_ctl(m)
            dd.show(false, false)   // скрытая — показ через таймер формы; показанная — только новое место (без второго интервала check_position)
            this.chartDrill_trackInstall()
            this.chartDrill_request(m)
        },
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): модель расшифровки кусочка — у формы (якорь у кусочка) и у вкладки Breakdown окна
        // легенды (tab: true, без якоря и без кнопки «окно легенды» в шапке)
        chartDrill_model(hit, anchor, tab = false) {
            const xKey = this.chartDrill_xKey()
            const list = this.flex?.series || []
            // цвет серии — как в плашке значений p199A (как нарисован; у штрихованной серии свотч — полосы), иначе — цвет легенды
            let color = '', swatch = ''
            try {
                if (typeof this.hoverValuesColor === 'function') color = drillCssColor(this.hoverValuesColor(hit.series))
                if (typeof this.hoverValuesSwatch === 'function') swatch = String(this.hoverValuesSwatch(hit.series) || '')
            } catch (e) { color = ''; swatch = '' }
            if (!color) { try { color = drillCssColor(legendSeriesColor(list, this.flex?.palette, hit.series, hit.attr)) } catch (e) { color = '' } }
            if (swatch.startsWith('url(')) swatch = ''
            const pt = drillPoint({ seriesBinding: hit.binding, seriesName: hit.series.name, attr: hit.attr, item: hit.item, xKey, xBinding: this.attr?.axisX_bindingX || xKey,
                xText: this.chartDrill_xText(hit.item, xKey), color, siblings: Object.values(this.attrs_by_binding || {}) })
            const loc = this.store.ui_locale?.()
            const model = {
                pointKey: hit.pointKey, pointIndex: this.data.indexOf(hit.item), anchor, pt,
                seriesTitle: pt.seriesTitle, color, swatch: swatch || color, xText: pt.xText, value: pt.value, valueText: drillFmt(pt.value, loc),
                state: 'loading', reason: '', total: null, totalText: '', aggregate: pt.aggregate, additive: false, measureTitle: '',
                dims: [], cands: [], top: drillTop(this.get_viewParam('drill-top', null)), suggestedTop: 5,
                custom: !!(drillDims(this.get_viewParam('drill-dims', null)) || this.get_viewParam('drill-top', null)),
                split: null, legendOn: !tab && !!this.isLegendGroupedActive?.(), ms: null, queries: null, blocks: this.chartDrill_blocksMem(), ctl: null,   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): !tab
                reserve: this.chartDrill_reserveH(tab),
                tab,   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): модель вкладки Breakdown окна легенды
            }
            if (pt.dim) {
                const W = this.WIDGET
                model.split = { dim: pt.dim, dimTitle: pt.dim, others: pt.key === DRILL_OTHERS_KEY, canUndo: !!(W && W._chartDrillUndo && W._chartDrillUndo[pt.measure]) }
            }
            return model
        },
        // ---------------- IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): расшифровка во вкладке Breakdown окна легенды
        // клик по кусочку графика с окном легенды: 'tab' — клик обработан (AttrChart.chart_onClick дальше не идёт); мимо кусочков — false (прежний клик по окну легенды)
        chartDrill_tabClick(e) {
            const hit = this.chartDrill_hit(e)
            if (!hit) return false
            STATS.tab.clicks++
            // форма у кусочка этого графика (режим переключили на лету) — закрыть
            const dd = this.store.dropdown
            if (dd && dd.visible && dd._chartDrillOwner === this && dd.chart_drill && !dd.pinned) { try { dd.hide(false, true) } catch (err) { /* формы нет */ } }
            // окно легенды: закрытое открывается, дата легенды — дата кусочка, привязка-стрелка — к кусочку (как прежний клик по точке до формы)
            if (!this.isLegendPanelShown()) {
                this.legendPanelVisible = true
                if (this.WIDGET) this.WIDGET._legendPanelVisible = true   // помнить выбор на виджете, как у кнопки легенды
                STATS.tab.legendOpened++
            }
            this.legendPointIndex = hit.pointIndex
            // дата легенды — дата кусочка и после выбора даты этим же нажатием: зона выбранной даты (setSelection по нажатию мыши → selectionChanged →
            // legendSyncToSelection, после клика, и эхо выбора стола) берёт ближайшую точку ЛЮБОЙ серии — у столбика рядом с линией другой серии это
            // соседняя дата (замер dev02 6YL_001: клик по столбику 2026-12 — зона и легенда 2026-11, вкладка Breakdown — 2026-12). Пока зона на той же
            // дате, что при этом клике, синхронизация легенды с зоной дату кусочка не перебивает (chartDrill_legendPinned); зона — как была
            this._drillLegendPin = { i: hit.pointIndex, sel: this.mouseSelecting ? this.mouseSelecting.i1 : null }
            this.legendAnchor = this.chartDrill_legendAnchor(hit)
            this.$refs.legendCmp?.invalidate?.()
            this.$nextTick(() => this.legendTetherUpdate?.())
            // расшифровка — во вкладку Breakdown; тот же кусочек уже расшифрован / грузится — без нового запроса
            const cur = this.legendDrill
            if (cur && cur.pointKey === hit.pointKey && cur.state !== 'error' && cur.state !== 'unsupported') STATS.tab.repeat++
            else this.chartDrill_tabOpen(hit)
            return 'tab'
        },
        // legendSyncToSelection (AttrChart): true — синхронизацию легенды с зоной выбранной даты i пропустить: легенда стоит на дате кусочка, кликнутого при
        // этой же зоне. Зона ушла на другую дату, дату легенды сменили иначе (сброс ×, другой клик) или вкладки выключены — привязка снимается
        chartDrill_legendPinned(i) {
            const p = this._drillLegendPin
            if (!p) return false
            if (p.sel !== i || this.legendPointIndex !== p.i || !this.chartDrill_tabOn()) { this._drillLegendPin = null; return false }
            STATS.tab.pinKept++
            return true
        },
        chartDrill_tabOpen(hit) {
            this.legendDrill = this.chartDrill_model(hit, null, true)
            this._drillTabRows = toRaw(this.doc && this.binding ? this.doc[this.binding] : null) || null   // строки, по которым считан кусочек (chartDrill_tabDataCheck)
            const m = this.legendDrill   // реактивная обёртка (data графика)
            m.ctl = this.chartDrill_ctl(m)
            if (this.legendTab_get() === 'breakdown') this.chartDrill_request(m)
            else { m.state = 'pending'; STATS.tab.deferred++ }   // открыта вкладка Legend — запрос при переходе на Breakdown (legendTab_select)
        },
        // якорь привязки-стрелки окна легенды в координатах виджета: у столбика — середина верха его блока (у стопки — верх своего блока), у линии — точка
        // по оси её серии (как AttrChart.hitAnchor у прежнего клика)
        chartDrill_legendAnchor(hit) {
            try {
                const flex = this.flex, wdiv = document.getElementById('WIDGET' + this.WIDGET.id)
                const wr = wdiv.getBoundingClientRect(), cr = flex.hostElement.getBoundingClientRect(), b = hit.box
                const ct = hit.series.chartType ?? flex.chartType
                const bar = ct === 0 || ct === 'Column'
                let x = NaN, y = NaN
                if (bar) { x = b.left + b.width / 2 - cr.left; y = b.top - cr.top }
                else {
                    const bx = flex.bindingX, v = Number(hit.item[hit.binding])
                    x = flex.axisX.convert(this.hoverXNum(bx ? hit.item[bx] : hit.pointIndex, hit.pointIndex))
                    y = (hit.series.axisY || flex.axisY).convert(Number.isFinite(v) ? v : 0)
                }
                if (!Number.isFinite(x)) x = b.left + b.width / 2 - cr.left
                if (!Number.isFinite(y)) y = b.top + b.height / 2 - cr.top
                return { x: (cr.left - wr.left) + x, y: (cr.top - wr.top) + y }
            } catch (e) { return null }
        },
        // вкладка окна легенды: выбор пользователя — на графике до перезагрузки (в памяти виджета, не сохраняется); по умолчанию Breakdown
        legendTab_get() {
            const W = this.WIDGET, k = String(this.attr_id ?? '')
            const v = this.legendTabSel || (W && W._chartLegendTab && W._chartLegendTab[k]) || 'breakdown'
            return v === 'legend' ? 'legend' : 'breakdown'
        },
        legendTab_select(name) {
            const v = name === 'legend' ? 'legend' : 'breakdown'
            this.legendTabSel = v
            const W = this.WIDGET
            if (W) W._chartLegendTab = { ...(W._chartLegendTab || {}), [String(this.attr_id ?? '')]: v }
            STATS.tab.switches++
            const m = this.legendDrill
            if (v === 'breakdown' && m && m.state === 'pending') this.chartDrill_request(m)
            this.$nextTick(() => this.legendTetherUpdate?.())
        },
        // пришли другие строки графика (отбор, период, перечитывание, разбиение серии) — расшифровка вкладки о прежних данных: вкладка — строка-подсказка
        chartDrill_tabDataCheck(rows) {
            if (!this.legendDrill || !this._drillTabRows) return
            if (toRaw(rows) === this._drillTabRows) return
            this.legendDrill = null
            this._drillTabRows = null
            this._drillSeq = (this._drillSeq || 0) + 1   // ответ прежнего запроса не нужен
            STATS.tab.stale++
        },
        // размер расшифровки во вкладке изменился (ответ, свёрнут / развёрнут блок): окно легенды — по новому размеру; высота — запас следующей загрузки (chartDrill_reserveH)
        chartDrill_tabFit(model) {
            this.$nextTick(() => {
                try { const el = this.$refs.legendCmp?.$refs?.drillHost; if (el && model && model.state === 'ok' && this.legendDrill === model) STATS.tabH = el.scrollHeight } catch (e) { /* окна нет */ }
                try { this.$refs.legendCmp?.relayout?.() } catch (e) { /* окна нет */ }
            })
        },
        chartDrill_ctl(m) {
            const vm = this
            return {
                split: (b) => vm.chartDrill_split(m, b),
                unsplit: () => vm.chartDrill_unsplit(m),
                open: (d, r) => vm.chartDrill_openItem(m, d, r),
                setDim: (b, on) => vm.chartDrill_setDim(m, b, on),
                setTop: (n) => vm.chartDrill_setTop(m, n),
                reset: () => vm.chartDrill_reset(m),
                legend: () => vm.chartDrill_legend(m),
                saveBlocks: (mem) => { try { localStorage.setItem(BLOCKS_KEY, JSON.stringify(mem || {})) } catch (e) { /* приватный режим */ } },
                fit: m.tab ? () => vm.chartDrill_tabFit(m) : null,   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): размер расшифровки во вкладке изменился — окно легенды по размеру (у формы — Dropdown.fit_review)
            }
        },
        // форма ячейки — один компонент на приложение: снять с неё всё, что относится к ячейке грида, и отдать графику
        chartDrill_takeDropdown(dd, anchor, model) {
            const old = dd.divCell
            if (old && old !== anchor) {
                try { old.removeEventListener('mouseenter', dd.mouseenter); old.removeEventListener('mouseleave', dd.mouseleave) } catch (e) { /* ячейка уже снята */ }
            }
            dd.clear_timer?.()   // показанная форма (ячейки или прежней точки) не прячется: содержимое и место меняются на месте, как при переходе между ячейками
            try { dd.pin_edgeRemove?.() } catch (e) { /* линии нет */ }   // линия-привязка открепленной формы грида — до смены виджета формы (страница прежнего виджета)
            dd.handlesRect = null
            Object.assign(dd, {
                cell_metrics: [], cell_rules: [], cell_rules_more: 0, cell_rules_lists: [], cf_applied: [], correction_info: [],
                cell_passport: null, cell_passport_loading: false, cell_series: null, cell_gantt: null, cell_group: null, cell_story: null, cell_story_preview: '',   // IE 2026 10 01 / ODOO-5800: блоки story — только у ячейки грида
                cell_versions: null,   // IE 2026 10 15 / ODOO-5800 (ЗП-№7, этап 4): блок VERSIONS — только у ячейки грида
                cell_docs: [], cell_docs_same: 0, sameNav_pos: 0, sameNav_total: 0,
                infl_formula: '', infl_formula_html: '', infl_formula_short: '',
                commandPanel_row: [], commandPanel_cell: [], commandPanel_row2: [], commandPanel_cell2: [],
                items: [], items_more_count: 0, items_can_loadFull: false, items_show_list: false,
                value: '', valueHTML: '', comment: '', showComment: false, showValue: false, showValueHTML: false, useValueHTML: false,
                dropdown_type: 'chart', isReadOnly: true,
            })
            dd.attr_col = null; dd.V = null; dd.parent_attr = { cell: {} }; dd.dataItem = null; dd.activeEditor = null; dd.is_editable = false
            dd.onSelect = null; dd.onMore = null; dd.onLoadFull = null; dd.onOpenList = null; dd.onEditFinish = null; dd.set_comment = null
            dd.parent_Vue = null   // следующая ячейка грида заново поставит свои обработчики (AttrGrid.dropdown_prepare: isChangeAttr)
            dd.WIDGET = this.WIDGET; dd.widget_id = this.widget_id; dd.vueObj = this; dd.binding = this.attr?.binding
            // режим формы (присоединённая / открепленная) — свой у графика: у грида того же виджета форма может быть открепленной по умолчанию
            // (cellForm_detachedOn), форма точки открывается у точки; пин формы точки пользователь переключает сам, и он живёт, пока форма у этого графика
            dd.pin_init?.({ widget_id: 'chartdrill:' + this.widget_id + ':' + (this.attr_id || '') })
            dd.key = 'chartdrill:' + this.widget_id + ':' + model.pointKey
            dd.anchor_cell = null
            dd.anchor_text = [model.xText, model.seriesTitle].filter(Boolean).join(' · ')
            dd.divCell = anchor
            dd.mouse_isInside = true
            dd._chartDrillOwner = this
            dd.chart_drill = model
        },
        // присоединённая форма закрывается уходом мыши с кусочка и формы — как у ячейки (у кусочка нет своих событий: курсор отслеживается по хосту графика)
        chartDrill_trackInstall() {
            const host = this.flex?.hostElement
            if (!host || this._drillTrack) return
            this._drillTrack = (ev) => {
                const dd = this.store.dropdown, m = dd && dd.chart_drill
                if (!dd || !dd.visible || !m || dd._chartDrillOwner !== this || dd.pinned) return
                const r = m.anchor && m.anchor.getBoundingClientRect ? m.anchor.getBoundingClientRect() : null
                if (!r) return
                const inside = ev.type !== 'mouseleave' && ev.clientX >= r.left - 4 && ev.clientX <= r.right + 4 && ev.clientY >= r.top - 4 && ev.clientY <= r.bottom + 4
                if (inside) dd.dropdown_mouseenter?.()
                else if (!dd.hide_timerId) dd.dropdown_mouseleave?.()
            }
            host.addEventListener('mousemove', this._drillTrack)
            host.addEventListener('mouseleave', this._drillTrack)
        },
        chartDrill_request(model) {
            const seq = this._drillSeq = (this._drillSeq || 0) + 1
            model.state = 'loading'; model.reason = ''
            const params = drillParams(model.pt, { dims: this.get_viewParam('drill-dims', null), top: model.top, more: 30 })
            STATS.requests++
            if (model.tab) STATS.tab.requests++   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды)
            const t0 = performance.now()
            try {
                this.store.executeWidgetMethod({ WIDGET: this.WIDGET }, { command: 'executeWidgetMethod', method: 'chart_drill', params,
                    record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
                    _response_callback: (answer) => {
                        // ответ нужен только форме: снять команду, чтобы стор не принял его за updateDoc записи виджета (как у паспорта ячейки)
                        if (answer) { answer.command = ''; delete answer.updates }
                        if (seq !== this._drillSeq) return
                        const ms = Math.round(performance.now() - t0)
                        STATS.answers++; STATS.ms.push(ms); if (STATS.ms.length > 50) STATS.ms.shift()
                        this.chartDrill_apply(model, answer && answer.chart_drill, ms)
                    } })
            } catch (e) {
                model.state = 'error'; model.reason = String(e && e.message || e).slice(0, 200)
            }
        },
        chartDrill_apply(model, cd, ms) {
            const loc = this.store.ui_locale?.()
            STATS.last = cd || null
            if (!cd) {
                STATS.unsupported++
                model.state = 'unsupported'
                model.reason = this.t('The server has no breakdown yet: the backend is older than the frontend')
                return
            }
            model.state = cd.state || 'ok'
            model.reason = cd.state === 'ok' ? '' : this.chartDrill_reasonText(cd)
            model.total = cd.total
            model.totalText = drillFmt(cd.total, loc)
            model.additive = !!(cd.measure && cd.measure.additive)
            model.aggregate = (cd.measure && cd.measure.aggregate) || model.aggregate
            model.measureTitle = (cd.measure && cd.measure.title) || ''
            model.top = cd.top || model.top
            model.suggestedTop = (cd.suggested && cd.suggested.top) || 5
            model.cands = (cd.candidates || []).map(c => ({ ...c }))
            model.ms = cd.ms != null ? cd.ms : ms; model.queries = cd.queries
            if (model.split) {
                const c = model.cands.find(x => x.binding === model.split.dim)
                model.split.dimTitle = (c && c.title) || model.split.dim
            }
            const emptyTitle = this.t('(empty)')
            model.dims = (cd.dims || []).map(d => ({
                binding: d.binding, title: d.title || d.binding, relation_segment: d.relation_segment || '', same_as: d.same_as || '', state: d.state || '',
                reason: d.reason || '', n: d.n || 0, zeros: d.zeros || 0, showMore: false,
                ...drillBlockRows(d, { total: cd.total, additive: model.additive, locale: loc, emptyTitle }),
            }))
            this.$nextTick(() => {
                if (model.tab) { this.chartDrill_tabFit(model); return }   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладка окна легенды — не форма ячейки
                try { this.store.dropdown?.fit_review?.() } catch (e) { /* формы нет */ }
                // высота формы с ответом (полная, без предела высоты) — запас следующей формы (chartDrill_reserveH)
                try { const dd = this.store.dropdown, el = dd && dd.chart_drill === model && dd.$refs && dd.$refs.dropdown; if (el) STATS.formH = el.scrollHeight + (el.offsetHeight - el.clientHeight) } catch (e) { /* формы нет */ }
            })
        },
        // причина пустой / недоступной расшифровки — текстом интерфейса (код бэка), подробность бэка — в скобках для технических случаев
        chartDrill_reasonText(cd) {
            const code = cd.reason_code || ''
            if (code === 'off') return this.t('The breakdown is switched off on the server (not-chart_drill)')
            if (code === 'not_list') return this.t('The breakdown works for list widgets with a data source')
            if (code === 'no_field') return this.t('The series field is not among the widget fields')
            if (code === 'calculated') return this.t('The series is calculated after the selection — it has no values by source dimensions')
            if (code === 'empty') return this.t('No source rows for this point')
            if (code === 'error' || cd.state === 'error') return this.t('The breakdown failed: {reason}', { reason: cd.reason || '?' })
            return cd.reason || ''
        },
        // «Split»: разбить серию в текущем графике по измерению — в памяти записи виджета; запись помечается изменённой, сохраняет пользователь
        chartDrill_split(model, dimB) {
            const W = this.WIDGET, rec = W && W.record, doc = rec && rec.doc
            if (!doc) return
            const cand = (model.cands || []).find(c => c.binding === dimB) || { binding: dimB, title: dimB }
            W._chartDrillUndo = W._chartDrillUndo || {}
            const back = this.chartSplitBack_flag() ? splitBackSnapshot(doc, W._chartDrillUndo) : null   // IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий): снимок до разбиения — уровень стрелки «назад»
            const prev = W._chartDrillUndo[model.pt.measure]
            if (prev) drillSplitUndo(doc, prev)   // повторное разбиение (другое измерение) — от исходного состояния, снимок прежний
            const undo = drillSplitApply(doc, { measure: model.pt.measure, dim: dimB, dimField: cand, top: model.top, xBinding: model.pt.xBinding })
            if (!undo) {
                this.store.show_notification?.({ text: this.t('The series field is not among the widget fields — the split is not possible'), status: 'warning' })
                return
            }
            W._chartDrillUndo[model.pt.measure] = prev || undo
            if (back) { W._chartSplitBack = splitBackPush(W._chartSplitBack, splitBackRecKey(rec), back, { measure: model.pt.measure, dim: dimB }); this.chartSplitBack_changed() }   // IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий)
            rec._meta = rec._meta || {}
            rec._meta.modified = true
            STATS.splits++
            this.chartDrill_closeModel(model)   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): форма — закрыть; вкладка — строка-подсказка (серии графика другие)
            this.chartDrill_reload()
        },
        chartDrill_unsplit(model) {
            const W = this.WIDGET, rec = W && W.record, doc = rec && rec.doc
            if (!doc) return
            const measure = model.pt.measure
            const undo = W._chartDrillUndo && W._chartDrillUndo[measure]
            if (undo) { drillSplitUndo(doc, undo); delete W._chartDrillUndo[measure] }
            else drillSplitRemove(doc, measure)
            if (W._chartSplitBack) { W._chartSplitBack = splitBackAfterUnsplit(W._chartSplitBack, splitBackRecKey(rec), measure, undo || null); this.chartSplitBack_changed() }   // IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий): уровни этой меры — из стека стрелки
            rec._meta = rec._meta || {}
            rec._meta.modified = true   // осторожно: другие правки записи могли быть после разбиения — признак не снимаем
            STATS.undos++
            this.chartDrill_closeModel(model)   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): форма — закрыть; вкладка — строка-подсказка (серии графика другие)
            this.chartDrill_reload()
        },
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): после Split / Undo split расшифровка кусочка устарела: форма у кусочка закрывается (как было), вкладка Breakdown —
        // строка-подсказка (чужую форму ячейки, открытую после, не трогать)
        chartDrill_closeModel(model) {
            if (model && model.tab) {
                if (this.legendDrill === model || toRaw(this.legendDrill) === toRaw(model)) { this.legendDrill = null; this._drillTabRows = null; this._drillSeq = (this._drillSeq || 0) + 1 }
                return
            }
            this.store.dropdown?.hide(false, true)
        },
        // IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий): стрелка «Back to the previous chart» в островке кнопок графика —
        // пока график разложен по сериям (стек уровней WIDGET._chartSplitBack, utils/chartSplitBack.js); клик — шаг назад на один уровень
        chartSplitBack_flag() {
            return chartSplitBack_on((k, d) => this.store?.setting?.(k, d))
        },
        chartSplitBack_shown() {
            void this.splitBackTick
            const W = this.WIDGET
            if (!W || !W.record || !this.chartSplitBack_flag()) return false
            return splitBackCan(W._chartSplitBack, splitBackRecKey(W.record))
        },
        chartSplitBack_changed() {
            this.splitBackTick++
            this.$nextTick(() => { try { this.WIDGET?.vueObj?.vizTitle_measure?.() } catch (e) { /* шапки нет */ } })   // островок сменил ширину — предел заголовка вкладки визуализации
        },
        chartSplitBack_back() {
            const W = this.WIDGET, rec = W && W.record, doc = rec && rec.doc
            if (!doc) return
            const r = splitBackPop(W._chartSplitBack, splitBackRecKey(rec), doc)
            if (!r) return
            W._chartSplitBack = r.state
            W._chartDrillUndo = r.undo
            rec._meta = rec._meta || {}
            rec._meta.modified = true
            STATS.backs++
            if (this.legendDrill) this.chartDrill_closeModel(this.legendDrill)   // расшифровка кусочка устарела, как после Split / Undo split
            const dd = this.store?.dropdown
            if (dd && dd._chartDrillOwner === this && dd.visible && dd.chart_drill) { try { dd.hide(false, true) } catch (e) { /* формы нет */ } }
            this.chartSplitBack_changed()
            this.chartDrill_reload()
        },
        // перечитать виджет с изменённой записью: ключ серверного кэша сбрасывается — запись уходит целиком (как у чипса пейджинга)
        chartDrill_reload() {
            const W = this.WIDGET
            if (!W || !W.vueObj) return
            delete W.widget_cache_key
            this.store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
        },
        chartDrill_openItem(model, d, r) {
            if (!r || !r.key) return
            try { this.store.executeStoreMethod(this, { command: 'widget_open', item: { id: r.key, segment: r.segment || d.relation_segment } }) } catch (e) { /* без открытия */ }
        },
        chartDrill_setDim(model, b, on) {
            const cur = (model.cands || []).filter(c => c.on).map(c => c.binding)
            const next = on ? cur.concat(cur.includes(b) ? [] : [b]) : cur.filter(x => x !== b)
            this.store.set_viewParam(this.WIDGET, this.attr.name, 'drill-dims', next.length ? next : null, this.attr)
            model.custom = true
            this.chartDrill_request(model)
        },
        chartDrill_setTop(model, n) {
            model.top = drillTop(n)
            this.store.set_viewParam(this.WIDGET, this.attr.name, 'drill-top', model.top, this.attr)
            model.custom = true
            this.chartDrill_request(model)
        },
        chartDrill_reset(model) {
            this.store.set_viewParam(this.WIDGET, this.attr.name, 'drill-dims', null, this.attr)
            this.store.set_viewParam(this.WIDGET, this.attr.name, 'drill-top', null, this.attr)
            model.custom = false
            model.top = drillTop(null)
            this.chartDrill_request(model)
        },
        chartDrill_legend(model) {
            if (!this.isLegendGroupedActive?.()) return
            if (!this.isLegendPanelShown()) { this.legendPanelVisible = true; if (this.WIDGET) this.WIDGET._legendPanelVisible = true }
            if (model.pointIndex >= 0) this.legendPointIndex = model.pointIndex
            this.$refs.legendCmp?.invalidate?.()
            this.$nextTick(() => this.legendTetherUpdate?.())
        },
    },
    beforeUnmount() {
        const host = this.flex?.hostElement
        if (host && this._drillTrack) { host.removeEventListener('mousemove', this._drillTrack); host.removeEventListener('mouseleave', this._drillTrack) }
        this._drillTrack = null
        const dd = this.store?.dropdown
        if (dd && dd._chartDrillOwner === this) { try { if (dd.visible) dd.hide(false, true) } catch (e) { /* формы нет */ } dd._chartDrillOwner = null; dd.chart_drill = null }
        try { this._drillAnchorEl?.remove() } catch (e) { /* уже снят */ }
    },
}
